import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  currentmonth: [],
  error: null,
  message: '',
};

const currentMonthReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CURRENTMONTH_GET_REQUEST:
    case actionTypes.CURRENTMONTH_ADD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.CURRENTMONTH_ADD_SUCCESS:
    case actionTypes.CURRENTMONTH_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        currentmonth: action.payload,
      };

    case actionTypes.CURRENTMONTH_ADD_FAILURE:
    case actionTypes.CURRENTMONTH_GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default currentMonthReducer
